import React, { Component } from 'react';
import styled from 'styled-components';

import RadioButton from './RadioButton';
import { connect } from 'react-redux';

export class CourseOptions extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            checked: 0,
            options: null,
            collisions: []
        }
    }

    componentDidMount() {
        let { course, selectedCourses, cart } = this.props;
        if (!course.value.acf.options) return null;

        const cartItem = cart.items.filter(item => item.post.id === course.value.id)[0];
        if (cartItem) {
            this.setState({
                checked: cartItem.timeplan_option.id,
                options: course.value.acf.options ? course.value.acf.options : null
            })
        }

        // Collision check
        let collisionItems = [];

        course.value.acf.options.forEach(option => {
            option.courses.forEach(item => {
                item.days.forEach(day => {
                    selectedCourses.forEach(courseToCheck => {
                        if (courseToCheck === course || !courseToCheck.value.acf.options) return;
                        if (courseToCheck.value.acf.period !== 'Helår' && courseToCheck.value.acf.period !== course.value.acf.period) return;
                        courseToCheck.value.acf.options.forEach(optionToCheck => {
                            let itemInCart = cart.items.filter(item => item.post.id === courseToCheck.value.id)[0];
                            // Only compare with selected options
                            if (itemInCart.timeplan_option.id !== optionToCheck.id) return;
                            optionToCheck.courses.forEach(courseSubjectToCheck => {
                                courseSubjectToCheck.days.forEach(itemToCheck => {
                                    if (itemToCheck.day === day.day
                                        && parseInt(day.time_block_start) <= parseInt(itemToCheck.time_block_end) 
                                        && parseInt(day.time_block_end) > parseInt(itemToCheck.time_block_start)
                                    ) {
                                        collisionItems.push(option.id);
                                    }
                                })
                            })
                        })
                    });
                })
            })
        }); 

        if(collisionItems.length > 0) this.setState({ collisions: [...collisionItems] });
    }

    handleOptionChange = (option, idx) => {
        let incoming = this.props.options;
        this.props.course.value.acf.options.map(item => {
            if(incoming.includes(item.id)) incoming.splice(incoming.indexOf(item.id, 0), 1);
        })
        incoming.push(option.id)
        
        this.setState({checked: idx},() => {
            this.props.handleOptionChange(incoming, option, this.props.course)
        })
    }

    render() {
        const { checked, options, collisions } = this.state;
        
        return (
            <Wrapper>
                { options ? options.sort((a,b) => a.availability === "available" - b).map((option, idx) => {
                    return (
                        <RadioButton 
                            data={option} 
                            key={idx}
                            idx={idx}
                            checked={checked === option.id}
                            collision={collisions.includes(option.id)}
                            available={option.availability === "available"}
                            handleOnChange={this.handleOptionChange}
                        />
                    )
                }) 
                :
                <RadioButton checked />
                }
            </Wrapper>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return Object.assign({
        cart: state.cart,
    });
};

export default connect(mapStateToProps, null)(CourseOptions);

const Wrapper = styled.div`
    display: flex;
`



// WEBPACK FOOTER //
// ./src/partials/modules/TimePlanNew/courseSelect/CourseOptions.js